const baseTableMixin = {
  data() {
    return {
      tableSearchQuery: {},
      tableData: [],
      tableLoading: false,

      // 当前表格 内容的筛选条件（点击搜索后的条件）
      tableCurrentQuery: {},
      tableTotal: 0,
      tableCurrentPage: 0,
      tablePageQuery: {
        pageSize: 15,
        pageNo: 1
      }
    };
  }
};
export default baseTableMixin;
